import React from 'react';
import TerminalManagement from '../Management';

const actions = {
    start: "CREATE_TERMINAL_SUBMIT",
    resolve: "CREATE_TERMINAL_SUCCESS",
    reject: "CREATE_TERMINAL_FAILED"
};

const NewTerminal = () => (
    <TerminalManagement
        headerName="Cadastrar Terminal"
        actions={actions}
    />
);

export default NewTerminal;


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/New/index.js